module.exports = __webpack_public_path__ + "img/bert-benefit-1.b6724222.jpg";